export const MAIN_ROUTES = [
  '/panel/dashboard',
  '/panel/billing',
  '/panel/benefits',
  '/panel/settings/general',
  '/panel/billing/details',
  '/panel/create-site',
  '/panel/notifications'
];
